import React from "react"
import { Repeater, Text, types } from "react-bricks/frontend"
import { ButtonBrickProps } from "../../../../react-bricks/button/Button"
import { ButtonStyle } from "../../../../react-bricks/components/button"

const AboTeaser: types.Brick = () => {
    return (
        <div className="rounded-base bg-darkblumine p-10 text-center text-white sm:rounded-lg sm:p-16 lg:p-24 xl:px-[110px]">
            <div className="mx-auto max-w-[1120px]">
                <Text
                    propName="headline"
                    placeholder="Lorem ipsum"
                    renderBlock={({ children }) => (
                        <h2 className="mb-5 font-gibson text-xl sm:text-4xl lg:text-[50px]/[56px]">
                            {children}
                        </h2>
                    )}
                />
                <Text
                    propName="text"
                    placeholder="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                    renderBlock={({ children }) => <p className="text-base sm:text-md lg:text-lg">{children}</p>}
                />
            </div>
            <div className="my-10 sm:my-16 lg:my-20">
                <div className="grid grid-cols-2 gap-x-3.5 gap-y-5 text-left sm:grid-cols-3 sm:gap-x-6 sm:gap-y-11 md:mx-[110px] md:gap-x-7 lg:mx-0 lg:grid-cols-6 lg:gap-3 xl:gap-7">
                    <Repeater propName="aboTeaserItem" />
                </div>
            </div>
            <Repeater
                propName="button"
                itemProps={
                    {
                        style: ButtonStyle.White,
                    } as ButtonBrickProps
                }
            />
        </div>
    )
}

AboTeaser.schema = {
    name: "AboTeaser",
    label: "Abo Teaser",
    hideFromAddMenu: true,
    repeaterItems: [
        {
            name: "aboTeaserItem",
            items: [
                {
                    type: "AboTeaserItem",
                    label: "Abo Teaser Item",
                    min: 1,
                    max: 6,
                },
            ],
        },
        {
            name: "button",
            items: [
                {
                    type: "Button",
                    label: "Button",
                    min: 1,
                    max: 1,
                },
            ],
        },
    ],
}

export default AboTeaser
